// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   darkmode: localStorage.getItem('darkmode')
//     ? JSON.parse(localStorage.getItem('darkmode'))
//     : false,
// };

// const darkmodeSlice = createSlice({
//   name: 'darkmode',
//   initialState,
//   reducers: {
//     setDarkmode: (state, action) => {
//       state.darkmode = action.payload;
//       localStorage.setItem('darkmode', JSON.stringify(action.payload));
//     },
//   },
// });

// export const {setDarkmode } = darkmodeSlice.actions;

// export default darkmodeSlice.reducer;


import { createSlice } from '@reduxjs/toolkit';

// The glass design is dark-only, so dark mode is always the default on load.
// (A saved "false" from the old light theme is ignored.)
const initialState = {
  darkmode: true,
};

const darkmodeSlice = createSlice({
  name: 'darkmode',
  initialState,
  reducers: {
    setDarkmode: (state, action) => {
      state.darkmode = action.payload;
      localStorage.setItem('darkmode', JSON.stringify(action.payload));
    },
  },
});

export const { setDarkmode } = darkmodeSlice.actions;

export default darkmodeSlice.reducer;